/**
 * Shared plain-text cell renderers for the person detail grids — no Badge
 * pills, an empty value renders a muted dash, a flag renders "Yes" or
 * nothing (docs/COMPONENT_PATTERNS.md "Read-Only Tables").
 */
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const dash = <span className="text-muted-foreground">—</span>;

/** Plain text; `''` / null → a muted dash. `muted` greys an inactive row. */
export function textCell(value: unknown, muted = false): ReactNode {
  const text = value == null ? "" : String(value);
  if (!text) return dash;
  return <span className={cn(muted && "text-muted-foreground")}>{text}</span>;
}

/** A long free-text value, truncated with the full text in the tooltip. */
export function truncatedCell(value: unknown): ReactNode {
  const text = value == null ? "" : String(value);
  if (!text) return dash;
  return (
    <span className="block truncate" title={text}>
      {text}
    </span>
  );
}

/** A boolean flag as the word "Yes" (the column header names the flag). */
export function flagLabel(t: TranslateFn, value: unknown): string {
  return value ? t("people:tabs.yes") : "";
}
